<div class="scann-scroll">
    <img [src]="data.url">
</div>
<div class="clearfix">
    <div class="pull-right">
        <button mat-button type="button" (click)="print()">Imprimir</button>
        <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
    </div>
</div>